import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useLocation } from "react-router-dom";
import { useAuth } from "context/authContext";
import BecomeContentCreator from "./BecomeContentCreator";

const BecomeContentCreatorData = () => {
  const [open, setOpen] = React.useState(false);
  const [profileImage, setProfileImage] = useState("/mnt/data/image.png");
  const location = useLocation();
  const handleClick = () => {
    setOpen(!open);
  };

  const handleEditImageClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const queryParams = new URLSearchParams(location.search);
  const user = queryParams.get("user");

  return (
    <>
      <Grid
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap={{ xs: 2, md: 5 }}
        px={{ xs: 2, md: 5 }}
      >
        <Box
          display="flex"
          px={{ xs: 0, md: 5 }}
          justifyContent="space-between"
          flexDirection={{ xs: "column", md: "row" }}
          gap={{ xs: 2, md: 5 }}
        >
          <Box
            fontWeight={700}
            pt={{ xs: 5, md: 0 }}
            fontSize="35px"
            color="#233F91"
            display="flex"
            alignItems="center"
          >
            Become a Content Creator
          </Box>
          <Typography
            display={"flex"}
            pt={{ xs: 0, md: 8 }}
            flexDirection={"column"}
            alignItems={"flex-end"}
            mt={1}
          >
            <Button sx={styleSheet.textButton}>Privacy Policy</Button>
            <Button sx={styleSheet.textButton}>Terms of Service</Button>
          </Typography>
          {/* <Grid display="flex" pt={{ xs: 0, md: 8 }} gap={2} alignItems="center" >
                        <Box position="relative">
                            <Avatar
                                alt="Serra Ozkaragoz"
                                src={profileImage}
                                sx={{ width: { xs: "65.63px", md: '100px' }, height: { xs: "65.63px", md: '100px' } }}
                            />
                            <IconButton sx={styleSheet.dowIcon}>
                                <label htmlFor="file-upload">
                                    <img
                                        alt="edit"
                                        src="/assets/icons/affdownload.png"
                                        style={{ cursor: 'pointer' }}
                                    />
                                </label>
                                <input
                                    id="file-upload"
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={handleEditImageClick} // Handle file upload
                                />
                            </IconButton>

                        </Box>
                        <Box display="flex" flexDirection="column" gap={1} color="#000000">
                            <Box onClick={handleClick} display={"flex"} gap={1} alignItems={"center"}>
                                <Box fontSize="20px" fontWeight={500}>
                                    Serra Ozkaragoz
                                </Box>
                                <KeyboardArrowDownIcon fontSize='large' />
                            </Box>

                            <Box fontSize={"16px"} fontWeight={400}
                            >serra@gmail.com</Box>

                        </Box>
                        {open &&
                            <Box sx={styleSheet.box}>
                                <Box

                                    display={"flex"} flexDirection={"column"} gap={2}
                                >


                                    <Typography fontSize={"14px"}
                                        fontWeight={500} color={"#505050"}
                                    >logout</Typography> </Box>
                            </Box>
                        }
                    </Grid> */}
        </Box>
        <Typography
          sx={{
            border: { xs: "1px solid #E9E9EA", md: "none" },
            width: { xs: "100%", md: "0" },
          }}
        ></Typography>
        <BecomeContentCreator />
      </Grid>
    </>
  );
};

export default BecomeContentCreatorData;

const styleSheet = {
  dowIcon: {
    position: "absolute",
    bottom: 0,
    right: 2,
    width: "20.12px",
    height: "20.12px",
  },
  box: {
    position: "absolute",
    top: "180px",
    zIndex: 1,
    right: { xs: "93px", md: "122px" },
    width: { xs: 172, md: 115 },
    bgcolor: "background.paper",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "8px",
    border: "0.5px solid #EDEDED",
    p: 2,
  },
  textButton: {
    color: "#000000",
    fontWeight: 400,
    fontSize: "17px",
  },
};
